<template>
  <div class="mobile-login">
    <nav-title title="手机号登录" :border="false"></nav-title>
    <div class="input-box">
      <div class="nav">
        <div class="left" @click="phoneChange">
          <span :class="activeName==1?'active':''" class="one">
            手机号登录
            <span class="line" :class="activeName==1?'active_name':''"></span>
          </span>
        </div>
        <div class="right" @click="codeChange">
          <span :class="activeName==2?'active':''" class="one">
            验证码登录
            <span class="line" :class="activeName==2?'active_name':''"></span>
          </span>
        </div>
      </div>
      <!-- 手机号登录 -->
      <div class="content" key="password" v-if="activeName === 1">
        <mobile-input
          ref="willfocus1"
          type="tel"
          :autofocus='focus'
          placeholder='请输入手机号'
          v-model="phone"
          @focus="inputError.phone1=''"
          @blur="phone.length !== 11 && phone.length !== 0 ? inputError.phone1 = '请输入正确的11位手机号' : ''"
          :errMsg='inputError.phone1'
          @inputTest="inputLimitPhone($data, 'phone')"
        ></mobile-input>
        <mobile-input 
          title="密码"
          v-model="password"
          placeholder='请输入密码'
          type='password'
          class="password"
          @focus="inputError.password1=''"
          @blur="password.length < 6 && password.length !==0 ? inputError.password1 = '请输入至少6位数的密码':''"
          :errMsg='inputError.password1'
          @inputTest="inputLimitNormal($data, 'password')"
        ></mobile-input>
        <div class="button" v-if='!isCanLogin1'>确认</div>
        <div class="c-button" v-else @click='loginByPhoneEvent'>确认</div>
      </div>

      <div class="content" key="sms" v-if="activeName === 2">
        <code-input
          ref="willfocus2"
          type="tel"
          v-model='mobilePhone'
          @inputTest="inputLimitPhone($data, 'mobilePhone')"
          @focus="inputError.mobilePhone1=''"
          @blur="mobilePhone.length !== 11 && mobilePhone.length !== 0 ? inputError.mobilePhone1 = '请输入正确的11位手机号' : ''"
          :errMsg='inputError.mobilePhone1'
          @getLoginCode='getLoginCode'
        ></code-input>
        <mobile-input 
          class="password"
          title='验证码'
          type='number'
          v-model="code"
          placeholder='请输入验证码'
          @focus="inputError.code1=''"
          @blur="code.length!==4 && code.length!==0 ? inputError.code1 ='请输入4位数验证码': ''"
          :errMsg='inputError.code1'
          @inputTest="inputLimitNormal($data, 'code')"
        ></mobile-input>
        <div class="button" v-if='!isCanLogin2'>确认</div>
        <div class="c-button" v-else @click='loginByCodeEvent'>确认</div>
      </div>
    </div>
    <!-- 图片验证 -->
    <ypsdk ref="ypsdk"/>
    <!-- 密码过于简单提示框 -->
    <popup ref="passwordTipsPopup" title="系统提示" confirmtext="确认" :warning="true" @confirm="$router.push('mobileInit')">
      <div class="password-tips-content" slot="content">
        <p>您的密码过于简单，请更换其他方式登录</p>
        <p>并在登录后前往个人中心修改密码</p>
      </div>
    </popup>
  </div>
</template>

<script>
// import BTime from 'best-calendar'
import domain from '@/config/systemDomain'
import CodeInput from '../components/code-input/code-input'
import ypsdk from '@/components/ypsdk/ypsdk'
import encryption from '@/assets/js/encryption.js'
import { inputLimitPhone, inputLimitNormal, isPasswordEffective } from '@/utils'
import { isAndroid } from '@/assets/js/util'
import { loginStorageDao, getJPushID } from '@/utils'
import Popup from '@/components/base/popup/popup.vue'

export default {
  data() {
    return {
      activeName: 1, // tabs 切换
      focus: true, //
      phone: '',  // 账号密码登录
      password: '',
      mobilePhone: '', // 手机验证码登录
      code: '', 
      lock: false, 
      inputError: {  // 错误语提示
        phone1: '',
        password1: '',
        mobilePhone1: '',
        code1: ''
      },
    }
  },

  computed: {
    isCanLogin1: function () {  // 账号密码
      return this.phone.length===11 && this.password.length > 5
    },

    isCanLogin2: function () { // 验证码
      return this.mobilePhone.length === 11 && this.code.length === 4
    },
  },

  watch: {
    activeName() {  // 监听tbs切换 初始化值
      this.focus = true
      this.phone = ''
      this.password = ''
      this.mobilePhone = ''
      this.code = ''
      this.$set(this.inputError, 'phone1', '')
      this.$set(this.inputError, 'password1', '')
      this.$set(this.inputError, 'mobilePhone1', '')
      this.$set(this.inputError, 'code1', '')
      this.$nextTick(() => {
        this.$refs['willfocus' + this.activeName].onFocusHandle()
      })
    }
  },

  created() {
    this.inputLimitPhone = inputLimitPhone
    this.inputLimitNormal = inputLimitNormal
    this.firstPicValid = true
    this.isAndroid = isAndroid
  },

  methods: {
    phoneChange() {
      this.activeName = 1
    },
    codeChange() {
      this.activeName = 2
    },

    getLoginCode() { // 获取验证码
      this.validCode()
    },

    validCode(captchaVerifyParam) {
      // if (this.lock) return 
      // this.lock = true
      const params = {
        action: 'login',
        phone: this.mobilePhone
      }

      if (captchaVerifyParam) { // 图片验证
        params.captcha_verify_param = captchaVerifyParam;
      }

      return this.$fetch.post({
        url: '/captcha',
        params,
      }).then( data => {
        if (data.need_captcha && this.firstPicValid) {
          // 图形验证
          this.firstPicValid = false
          this.ypValid()
        } else {
            // 直接获取验证码
          this.firstPicValid = true
        }
        return data
      }, e => {
          if (!e.success && e.error_text.includes('图形验证') && this.firstPicValid) {
            this.firstPicValid = false
            return this.ypValid()
          }
          this.firstPicValid = true
          if (captchaVerifyParam) return Promise.reject(e)
      })
    },

    ypValid() {
      // this.countDown && this.countDown.stop(true)
      this.$nextTick(() => {
        this.$refs.ypsdk.ready(
          captchaVerifyParam => this.validCode(captchaVerifyParam)
        ).then(() => {}, () => {})
      })
    },
    // 验证码登录
    loginByCodeEvent() {
      if (this.phoneLock ) return 
      this.phoneLock = true 
      this.$fetch.post({
        url: '/login?method=login_by_phone_code',
        params: {
          phone: this.mobilePhone,
          code: this.code
        }
      }).then( data => {
        if (data.success) {
          loginStorageDao.setData({
            hasLogin: true,
            type: 'phone'
          });
          // 判断是否绑定微信 
          if (data.bind_wx) { 
            //  跳转 
            this.bindJpushId()
          } else {
            this.$router.push({
              path: '/wxBind'
            })
          }
        }
      }, e => {
        if (e.error_text.includes('验证码')) {
          this.$set(this.inputError, 'code1', '验证码过期或错误')
        }else {
          this.openMessage(0, e.error_text || '登录失败')
        }
        this.phoneLock = false
      })
    },
    // 账号密码登录
    loginByPhoneEvent() {
      if (this.pwdLock) return
      if(!isPasswordEffective(this.password)){
         this.$refs["passwordTipsPopup"].open()
         return false
      }
      this.pwdLock = true 
      this.$fetch.post({
        url: '/login?method=login_by_phone_password',
        params: {
          phone: this.phone,
          password: encryption(this.password)
        }
      }).then( data => {
        if (data.success) {
          loginStorageDao.setData({
            hasLogin: true,
            type: 'phone'
          });
          if (data.bind_wx) {
            this.bindJpushId()
            this.pwdLock = false
          } else {
            this.$router.push('/wxBind')
          }
        } else  {
          this.openMessage(0, '用户名或密码错误')
        }
      }, e => {
        if (e.error_text.includes('密码错误')) {
          this.openMessage(0, '用户名或密码错误')
        } else {
          this.openMessage(0, e.error_text || '登录失败')
        }
        this.pwdLock = false
      })
    },

    bindJpushId() {
      getJPushID()
        .then(val => {
          this.$fetch.post({
            url: '/updatedevicealias',
            params: {
              registration_id: val
            }
          }).then(() => {
            window.location.href = domain.center_domain_m + '/#/loading'
          }).catch(() => {
            window.location.href = domain.center_domain_m + '/#/loading'
          })
        })
    }
  },

  components: {
    CodeInput,
    ypsdk,
    Popup
  }
};
</script>

<style lang='scss' scoped>
html, body {
  ::-webkit-scrollbar {
      width: 0;
      height: 16px;
      background-color: #F5F5F5;
  }
}
.mobile-login {
  width: 100%;
  height: 100%;
  // min-height: 100%;
  background-color: #fff;
  overflow: hidden;

  .input-box {
    padding: 0 10px;

    .nav {
      margin-bottom: 40px;
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;

      .left,
      .right {
        flex: 1;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);

        .one {
          position: relative;
          display: inline-block;
          height: 100%;
          font-size: 14px;
          color: #666;
        }

        .line {
          position: absolute;
          width: 30px;
          height: 2px;
          bottom: -1px;
          left: 20px;
          // background-color: #009688;
        }

        .active_name {
          background-color: #009688;
        }

        .active {
          // background-color: #009688;
          color: #009688;
          font-weight: bold;
        }
      }
    }

    .content {
      .button {
        margin-top: 20px;
        width: 100%;
        height: 50px;
        line-height: 50px;
        border-radius: 5px;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        background-color: #ddd;
      }

      .c-button {
        margin-top: 20px;
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        background: #009688;
        box-shadow: 0 2px 5px 0 rgba(0,150,136,0.60);
        border-radius: 5px;

        &:active {
          background-color: rgba(0,134,122,100);
        }
      }
    }
    .password {
      margin-top: 10px;
    }
  }

  .footer {
    margin-top: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // position: fixed;
    width: 100%;
    // bottom: 10%;

    .icon {
      font-size: 50px;
    }

    .tip {
      margin-top: 6px;
      font-size: 14px;
      color: #666;
    }
  }
  .password-tips-content {
    margin: 20px 0;
    text-align: center;
    p {
      padding: 5px;
    }
  }
}
</style>
